"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.inView = inView;

var _Base = _interopRequireDefault(require("./Base.js"));

var _EventType = _interopRequireDefault(require("../events/EventType.js"));

var _Property = _interopRequireDefault(require("./Property.js"));

var _EventType2 = _interopRequireDefault(require("../render/EventType.js"));

var _State = _interopRequireDefault(require("../source/State.js"));

var _asserts = require("../asserts.js");

var _obj = require("../obj.js");

var _events = require("../events.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/layer/Layer
 */


/**
 * @typedef {function(import("../PluggableMap.js").FrameState):HTMLElement} RenderFunction
 */

/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     'change:source', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|'change:source'|
 *     import("../render/EventType").LayerRenderEventTypes, Return>} LayerOnSignature
 */

/**
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {SourceType} [source] Source for this layer.  If not provided to the constructor,
 * the source can be set by calling {@link module:ol/layer/Layer~Layer#setSource layer.setSource(source)} after
 * construction.
 * @property {import("../PluggableMap.js").default|null} [map] Map.
 * @property {RenderFunction} [render] Render function. Takes the frame state as input and is expected to return an
 * HTML element. Will overwrite the default rendering for the layer.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */

/**
 * @typedef {Object} State
 * @property {import("./Layer.js").default} layer Layer.
 * @property {number} opacity Opacity, the value is rounded to two digits to appear after the decimal point.
 * @property {boolean} visible Visible.
 * @property {boolean} managed Managed.
 * @property {import("../extent.js").Extent} [extent] Extent.
 * @property {number} zIndex ZIndex.
 * @property {number} maxResolution Maximum resolution.
 * @property {number} minResolution Minimum resolution.
 * @property {number} minZoom Minimum zoom.
 * @property {number} maxZoom Maximum zoom.
 */

/**
 * @classdesc
 * Base class from which all layer types are derived. This should only be instantiated
 * in the case where a custom layer is added to the map with a custom `render` function.
 * Such a function can be specified in the `options` object, and is expected to return an HTML element.
 *
 * A visual representation of raster or vector map data.
 * Layers group together those properties that pertain to how the data is to be
 * displayed, irrespective of the source of that data.
 *
 * Layers are usually added to a map with {@link import("../PluggableMap.js").default#addLayer map.addLayer()}. Components
 * like {@link module:ol/interaction/Draw~Draw} use unmanaged layers
 * internally. These unmanaged layers are associated with the map using
 * {@link module:ol/layer/Layer~Layer#setMap} instead.
 *
 * A generic `change` event is fired when the state of the source changes.
 *
 * Please note that for performance reasons several layers might get rendered to
 * the same HTML element, which will cause {@link import("../PluggableMap.js").default#forEachLayerAtPixel map.forEachLayerAtPixel()} to
 * give false positives. To avoid this, apply different `className` properties to the
 * layers at creation time.
 *
 * @fires import("../render/Event.js").RenderEvent#prerender
 * @fires import("../render/Event.js").RenderEvent#postrender
 *
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @template {import("../renderer/Layer.js").default} [RendererType=import("../renderer/Layer.js").default]
 * @api
 */
var Layer =
/** @class */
function (_super) {
  __extends(Layer, _super);
  /**
   * @param {Options<SourceType>} options Layer options.
   */


  function Layer(options) {
    var _this = this;

    var baseOptions = (0, _obj.assign)({}, options);
    delete baseOptions.source;
    _this = _super.call(this, baseOptions) || this;
    /***
     * @type {LayerOnSignature<import("../events").EventsKey>}
     */

    _this.on;
    /***
     * @type {LayerOnSignature<import("../events").EventsKey>}
     */

    _this.once;
    /***
     * @type {LayerOnSignature<void>}
     */

    _this.un;
    /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */

    _this.mapPrecomposeKey_ = null;
    /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */

    _this.mapRenderKey_ = null;
    /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */

    _this.sourceChangeKey_ = null;
    /**
     * @private
     * @type {RendererType}
     */

    _this.renderer_ = null;
    /**
     * @protected
     * @type {boolean}
     */

    _this.rendered = false; // Overwrite default render method with a custom one

    if (options.render) {
      _this.render = options.render;
    }

    if (options.map) {
      _this.setMap(options.map);
    }

    _this.addChangeListener(_Property["default"].SOURCE, _this.handleSourcePropertyChange_);

    var source = options.source ?
    /** @type {SourceType} */
    options.source : null;

    _this.setSource(source);

    return _this;
  }
  /**
   * @param {Array<import("./Layer.js").default>} [opt_array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */


  Layer.prototype.getLayersArray = function (opt_array) {
    var array = opt_array ? opt_array : [];
    array.push(this);
    return array;
  };
  /**
   * @param {Array<import("./Layer.js").State>} [opt_states] Optional list of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */


  Layer.prototype.getLayerStatesArray = function (opt_states) {
    var states = opt_states ? opt_states : [];
    states.push(this.getLayerState());
    return states;
  };
  /**
   * Get the layer source.
   * @return {SourceType|null} The layer source (or `null` if not yet set).
   * @observable
   * @api
   */


  Layer.prototype.getSource = function () {
    return (
      /** @type {SourceType} */
      this.get(_Property["default"].SOURCE) || null
    );
  };
  /**
   * @return {SourceType|null} The source being rendered.
   */


  Layer.prototype.getRenderSource = function () {
    return this.getSource();
  };
  /**
   * @return {import("../source/State.js").default} Source state.
   */


  Layer.prototype.getSourceState = function () {
    var source = this.getSource();
    return !source ? _State["default"].UNDEFINED : source.getState();
  };
  /**
   * @private
   */


  Layer.prototype.handleSourceChange_ = function () {
    this.changed();
  };
  /**
   * @private
   */


  Layer.prototype.handleSourcePropertyChange_ = function () {
    if (this.sourceChangeKey_) {
      (0, _events.unlistenByKey)(this.sourceChangeKey_);
      this.sourceChangeKey_ = null;
    }

    var source = this.getSource();

    if (source) {
      this.sourceChangeKey_ = (0, _events.listen)(source, _EventType["default"].CHANGE, this.handleSourceChange_, this);
    }

    this.changed();
  };
  /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").default>>} Promise that resolves with
   * an array of features.
   */


  Layer.prototype.getFeatures = function (pixel) {
    if (!this.renderer_) {
      return new Promise(function (resolve) {
        return resolve([]);
      });
    }

    return this.renderer_.getFeatures(pixel);
  };
  /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */


  Layer.prototype.getData = function (pixel) {
    if (!this.renderer_ || !this.rendered) {
      return null;
    }

    return this.renderer_.getData(pixel);
  };
  /**
   * In charge to manage the rendering of the layer. One layer type is
   * bounded with one layer renderer.
   * @param {?import("../PluggableMap.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target which the renderer may (but need not) use
   * for rendering its content.
   * @return {HTMLElement} The rendered element.
   */


  Layer.prototype.render = function (frameState, target) {
    var layerRenderer = this.getRenderer();

    if (layerRenderer.prepareFrame(frameState)) {
      this.rendered = true;
      return layerRenderer.renderFrame(frameState, target);
    }
  };
  /**
   * Called when a layer is not visible during a map render.
   */


  Layer.prototype.unrender = function () {
    this.rendered = false;
  };
  /**
   * For use inside the library only.
   * @param {import("../PluggableMap.js").default|null} map Map.
   */


  Layer.prototype.setMapInternal = function (map) {
    if (!map) {
      this.unrender();
    }

    this.set(_Property["default"].MAP, map);
  };
  /**
   * For use inside the library only.
   * @return {import("../PluggableMap.js").default|null} Map.
   */


  Layer.prototype.getMapInternal = function () {
    return this.get(_Property["default"].MAP);
  };
  /**
   * Sets the layer to be rendered on top of other layers on a map. The map will
   * not manage this layer in its layers collection, and the callback in
   * {@link module:ol/Map~Map#forEachLayerAtPixel} will receive `null` as layer. This
   * is useful for temporary layers. To remove an unmanaged layer from the map,
   * use `#setMap(null)`.
   *
   * To add the layer to a map and have it managed by the map, use
   * {@link module:ol/Map~Map#addLayer} instead.
   * @param {import("../PluggableMap.js").default|null} map Map.
   * @api
   */


  Layer.prototype.setMap = function (map) {
    if (this.mapPrecomposeKey_) {
      (0, _events.unlistenByKey)(this.mapPrecomposeKey_);
      this.mapPrecomposeKey_ = null;
    }

    if (!map) {
      this.changed();
    }

    if (this.mapRenderKey_) {
      (0, _events.unlistenByKey)(this.mapRenderKey_);
      this.mapRenderKey_ = null;
    }

    if (map) {
      this.mapPrecomposeKey_ = (0, _events.listen)(map, _EventType2["default"].PRECOMPOSE, function (evt) {
        var renderEvent =
        /** @type {import("../render/Event.js").default} */
        evt;
        var layerStatesArray = renderEvent.frameState.layerStatesArray;
        var layerState = this.getLayerState(false); // A layer can only be added to the map once. Use either `layer.setMap()` or `map.addLayer()`, not both.

        (0, _asserts.assert)(!layerStatesArray.some(function (arrayLayerState) {
          return arrayLayerState.layer === layerState.layer;
        }), 67);
        layerStatesArray.push(layerState);
      }, this);
      this.mapRenderKey_ = (0, _events.listen)(this, _EventType["default"].CHANGE, map.render, map);
      this.changed();
    }
  };
  /**
   * Set the layer source.
   * @param {SourceType|null} source The layer source.
   * @observable
   * @api
   */


  Layer.prototype.setSource = function (source) {
    this.set(_Property["default"].SOURCE, source);
  };
  /**
   * Get the renderer for this layer.
   * @return {RendererType|null} The layer renderer.
   */


  Layer.prototype.getRenderer = function () {
    if (!this.renderer_) {
      this.renderer_ = this.createRenderer();
    }

    return this.renderer_;
  };
  /**
   * @return {boolean} The layer has a renderer.
   */


  Layer.prototype.hasRenderer = function () {
    return !!this.renderer_;
  };
  /**
   * Create a renderer for this layer.
   * @return {RendererType} A layer renderer.
   * @protected
   */


  Layer.prototype.createRenderer = function () {
    return null;
  };
  /**
   * Clean up.
   */


  Layer.prototype.disposeInternal = function () {
    if (this.renderer_) {
      this.renderer_.dispose();
      delete this.renderer_;
    }

    this.setSource(null);

    _super.prototype.disposeInternal.call(this);
  };

  return Layer;
}(_Base["default"]);
/**
 * Return `true` if the layer is visible and if the provided view state
 * has resolution and zoom levels that are in range of the layer's min/max.
 * @param {State} layerState Layer state.
 * @param {import("../View.js").State} viewState View state.
 * @return {boolean} The layer is visible at the given view state.
 */


function inView(layerState, viewState) {
  if (!layerState.visible) {
    return false;
  }

  var resolution = viewState.resolution;

  if (resolution < layerState.minResolution || resolution >= layerState.maxResolution) {
    return false;
  }

  var zoom = viewState.zoom;
  return zoom > layerState.minZoom && zoom <= layerState.maxZoom;
}

var _default = Layer;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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